<template>
  <div class="chartNum">
    <div class="box-item">
      <li
        :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
        v-for="(item,index) in orderNum"
        :key="index"
      >
        <span v-if="!isNaN(item)">
          <i ref="numberItem">
            <span class="nums" v-for="i of 10" :key="i">{{i-1}}</span>
          </i>
        </span>
        <span class="comma" v-else>{{item}}</span>
      </li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    num: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      orderNum: ['0', '0', '0', '0', '0', '0'] // 默认订单总数
    }
  },
  mounted () {
    setTimeout(() => {
      this.toOrderNum(this.num) // 这里输入数字即可调用
    }, 500)
  },
  methods: {
    // 设置文字滚动
    setNumberTransform () {
      const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum.filter(item => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(0, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum (num) {
      num = `${num}`
      // 把订单数变成字符串
      if (num.length < 6) {
        num = '0' + num // 如未满6位数，添加"0"补位
        this.toOrderNum(num) // 递归添加"0"补位
      } else if (num.length === 6) {
        // 订单数中加入逗号
        this.orderNum = num.split('') // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过6位显示异常
        this.$message.warning('总量数字过大')
      }
      this.setNumberTransform()
    }
  },
  watch: {
    num () {
      setTimeout(() => {
        this.toOrderNum(this.num) // 这里输入数字即可调用
      }, 500)
    }
  }
}
</script>

<style scoped lang='less'>
/*订单总量滚动数字设置*/
.box-item {
  position: relative;
  height: 60px;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  list-style: none;
  color: #ffffff;
  // writing-mode: vertical-lr;
  // text-orientation: upright;
  /*文字禁止编辑*/
  user-select: none;
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 20px;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    // writing-mode: vertical-rl;
    // text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  float: left;
  width: 19px;
  height: 24px;
  text-align: center;
  /* 背景图片 */
  background: url(/static/images/blue.png) no-repeat center center;
  background-size: 100% 100%;
  list-style: none;
  margin-right: 3px;
  border-radius: 4px;
  // border: 1px solid rgba(221, 221, 221, 1);
  & > span {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    & > i {
      display: inline-block;
      font-style: normal;
      width: 100%;
      transform: translate(0, 0);
      transition: transform 1s ease-in-out;
    }
  }
}
.number-item:last-child {
  margin-right: 0;
}

.nums {
  display: block;
  width: 19px;
  height: 24px;
  line-height: 24px;
}
</style>
<style scoped>
@media screen and (min-width: 1px) {
  .nums,
  .number-item {
    width: 15px;
    height: 21px;
    line-height: 21px;
    font-size: 1rem;
  }
}
@media screen and (min-width: 1367px) {
  .nums,
  .number-item {
    width: 16px;
    height: 22px;
    line-height: 22px;
    font-size: 1rem;
  }
}
@media screen and (min-width: 1601px) {
  .nums,
  .number-item {
    width: 18px;
    height: 23px;
    line-height: 23px;
    font-size: 1rem;
  }
}
@media screen and (min-width: 1921px) {
  .nums,
  .number-item {
    width: 20px;
    height: 24px;
    line-height: 24px;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/dataBI/flot.vue